export const getTourName = (name: any, lang: string) => {
  if (Array.isArray(name)) {
    return name.find((item: any) => item.language === lang)?.text ?? name[0]?.text ?? "";
  }
  if (typeof name === "string" && name.charAt(0) === "[") {
    try {
      const parsed = JSON.parse(name);
      return parsed.find((item: any) => item.language === lang)?.text ?? parsed[0]?.text ?? name;
    } catch { return name; }
  }
  return name ?? "";
};

export const getTourDescription = (description: any, lang: string) => {
  if (Array.isArray(description)) {
    return description.find((item: any) => item.language === lang)?.text ?? description[0]?.text ?? "";
  }
  if (typeof description === "string" && description.charAt(0) === "[") {
    try {
      const parsed = JSON.parse(description);
      return parsed.find((item: any) => item.language === lang)?.text ?? parsed[0]?.text ?? description;
    } catch { return description; }
  }
  return description ?? "";
};

export const getStringOrParsedJson = (data: any) => {
  if (Array.isArray(data)) {
    return data;
  }
  if (typeof data === "string" && data.charAt(0) === "[") {
    try { return JSON.parse(data); } catch { /* fall through */ }
  }
  return [{ text: data ?? "", language: "en" }];
};
